<template>
    <DModal
        :show="showModal"
        overflow-auto
        :title="__('tools.php_eol.batches.exclude_products_form.title')"
        :message="__('tools.php_eol.batches.exclude_products_form.message')"
        @close="$emit('close-modal')"
        @confirm="submitForm"
    >
        <template #default>
            <DCard
                padding
                class="min-height"
            >
                <DFormRow
                    :label="__('tools.php_eol.batches.exclude_products_form.excluded_products')"
                    is-required
                    :error="errorsData.excluded_products"
                >
                    <DMultiSelect
                        id="excluded_products"
                        :options="allModuleProducts"
                        :selected="excludedModuleProducts"
                        :selection="true"
                        selection-type="tags"
                        :search="true"
                        @update="(values) => updateExcludedProducts(values)"
                    />
                </DFormRow>
            </DCard>
        </template>
    </DModal>
</template>

<script setup>

import { useForm } from '@inertiajs/vue3'
import { route } from '~@/Composables/route'
import { ref } from 'vue'

const props = defineProps({
    errors: {
        type: Object,
        default: () => { return {} }
    },
    showModal: {
        type: Boolean,
        default: false
    },
    allModuleProducts: {
        type: Array,
        default () {
            return []
        }
    },
    excludedModuleProducts: {
        type: Array,
        default () {
            return []
        }
    },
    activeModule: {
        type: String,
        default () {
            return ''
        }
    }
})

const errorsData = ref(props.errors)

const form = useForm({
    excluded_products: props.excludedModuleProducts ?? [],
    module: props.activeModule
})

const emit = defineEmits(['close-modal', 'form-submitted'])

const updateExcludedProducts = function (values) {
    form.excluded_products = values
}

const submitForm = () => {
    form.post(route('contracts.php-eol-exclude-contracts.store'), {
        onSuccess: () => {
            emit('close-modal')
        },
        onError: (error) => {
            errorsData.value = error
        }
    })
}
</script>

<style scoped lang="scss">
:deep(.modal-box) {
        max-height: none !important;
}
.min-height {
    min-height: 400px;
}
</style>
